import { AbstractComponentPropTypes } from '../../../../ui/cms/registries';
import { LinkDefination } from '../../types/common';
import { ContentCardCommonProps } from '../../ContentCard/types/propsTypes';

export interface ResourceCardProps extends AbstractComponentPropTypes, ContentCardCommonProps {
  subTitle?: string;
  resourceType?: ContentResourceType;
  detailPage?: boolean;
  link?: LinkDefination;
  customClass?: string;
}

type ContentResourceType = keyof typeof ResourceType;
export enum ResourceType {
  image = 'image',
  video = 'video',
  pdf = 'pdf',
  audio = 'audio',
}
